import { useState } from 'react'
import styled from 'styled-components'
import Logo1 from '../../assets/abf/logo1.png'
import Logo2 from '../../assets/abf/logo2.png'
import { Button, Container, Content, Form, FormGroup, Input, Label, Logo } from '../login/styled'
import PrizeDraw from './PrizeDraw'

const ButtonSistema = styled(Button)`
  font-size: 11px;
  max-width: 100px;
`;

const ErrorLabel = styled.label`
  color: red;
  margin-top: -10px;
  font-size: 14px;
`;

interface PropsAuth {
  setPrizeDraw: any
}

export default function Auth ({ setPrizeDraw }: PropsAuth) {
  const [pwd, setPwd] = useState("");
  const [pwdActive, setPwdActive] = useState(false);
  
  return (
    <>
      {pwdActive ? <PrizeDraw setPrizeDraw={setPrizeDraw} /> : (
        <Container>
          <Content>
            <Logo src={Logo1} alt="Logo" />
            <Logo src={Logo2} alt="Logo" />
            <Form>
              <FormGroup>
                <Label htmlFor="pwd">Senha:</Label>{'  '}
                <Input type='password' id="pwd" autoComplete="off" onChange={(e) => setPwd(e.target.value)} />
                <br />
                <br />
                <br />
                <ButtonSistema onClick={() => {
                  if (pwd === "respira") {
                    setPwdActive(true)
                  } else {
                    alert("Senha incorreta")
                    setPrizeDraw(false)
                  }
                    }}>SORTEAR</ButtonSistema>   
              </FormGroup>
            </Form>  
          </Content>  
        </Container>      
      )}
    </>
  )
}